var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClientInBed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "31.2,16.3 31.2,18.1 8.7,18.1 8.7,10.6 5,10.6 5,29.4 8.7,29.4 8.7,23.8 31.2,23.8 31.2,29.4 35,29.4 35,16.3  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7,16.9c-0.6-1.9-3.7-3.2-7.7-3.2s-7.1,1.3-7.7,3.2H30.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4,14.9c1.3,0,2.5,0.9,2.5,2.1H9C9,15.8,10.1,14.9,11.4,14.9z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientInBed);
export default __webpack_public_path__ + "static/media/client-in-bed.1e6a995cd2fffbe1dfb28cc1cbcf3ff9.svg";
export { ForwardRef as ReactComponent };